<script lang="ts">
import { AppPagination } from "@/shared/components/app-pagination/app-pagination.ts";
export default AppPagination;
</script>

<template>
    <div
        class="pagination app-pagination"
        id="c-app-pagination"
        v-if="total > 0"
        :class="isTransparent && 'is-transparent'"
    >
        <div class="container pagination__container">
            <div class="pagination__block">
                <a
                    class="pagination__item pagination__arrow-first"
                    href="#"
                    @click.stop.prevent="goToFirstPage()"
                    v-if="hasHiddenPagesBeforeCurrentPage"
                >
                    <svg
                        class="sprite-icon pagination__arrow-icon"
                        width="16"
                        height="16"
                    >
                        <use xlink:href="/img/sprite.svg#chevron-right-2"></use>
                    </svg>
                </a>

                <a
                    class="pagination__item pagination__arrow-prev"
                    href="#"
                    @click.stop.prevent="goToPreviousPage()"
                    v-if="hasHiddenPagesBeforeCurrentPage"
                >
                    <svg
                        class="sprite-icon pagination__arrow-icon"
                        width="16"
                        height="16"
                    >
                        <use xlink:href="/img/sprite.svg#chevron-left"></use>
                    </svg>
                </a>

                <a
                    class="pagination__item pagination__num"
                    href="#"
                    @click.stop.prevent="goToPage(1)"
                    v-if="canShowFirstPage"
                >
                    1
                </a>

                <span
                    class="pagination__item pagination__dots"
                    v-if="hasHiddenPagesBeforeCurrentPage"
                >
                    ...
                </span>

                <a
                    class="pagination__item pagination__num"
                    href="#"
                    v-for="page in fewItemsBeforeCurrentPage"
                    :key="page"
                    @click.stop.prevent="goToPage(page)"
                >
                    {{ page }}
                </a>

                <span class="pagination__item pagination__num active">
                    {{ currentPage }}
                </span>

                <a
                    class="pagination__item pagination__num"
                    href="#"
                    v-for="page in fewItemsAfterCurrentPage"
                    :key="page"
                    @click.stop.prevent="goToPage(page)"
                >
                    {{ page }}
                </a>

                <span
                    class="pagination__item pagination__dots"
                    v-if="hasHiddenPagesAfterCurrentPage"
                >
                    ...
                </span>

                <a
                    class="pagination__item pagination__num"
                    href="#"
                    @click.stop.prevent="goToLastPage()"
                    v-if="canShowLastPage"
                >
                    {{ totalPages }}
                </a>

                <a
                    class="pagination__item pagination__arrow-next"
                    href="#"
                    @click.stop.prevent="goToNextPage()"
                    v-if="hasHiddenPagesAfterCurrentPage"
                >
                    <svg
                        class="sprite-icon pagination__arrow-icon"
                        width="16"
                        height="16"
                    >
                        <use xlink:href="/img/sprite.svg#chevron-right"></use>
                    </svg>
                </a>
                <a
                    class="pagination__item pagination__arrow-last"
                    href="#"
                    @click.stop.prevent="goToLastPage()"
                    v-if="hasHiddenPagesAfterCurrentPage"
                >
                    <svg
                        class="sprite-icon pagination__arrow-icon"
                        width="16"
                        height="16"
                    >
                        <use xlink:href="/img/sprite.svg#chevron-right-2"></use>
                    </svg>
                </a>
            </div>
            <div class="pagination__show p-d-none p-d-md-block">
                <div class="select select--small">
                    <div class="select__label">
                        <i18n-t keypath="pagination.show" />
                        :
                    </div>
                    <app-dropdown
                        v-model="perPageModel"
                        :type="'single'"
                        :show-checkbox="false"
                        :options="perPageOptions"
                        :get-value="(option) => option.value"
                        :get-label="(option) => option.label"
                    ></app-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>
